import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sousuo",
  "use": "icon-sousuo-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-sousuo\"><path d=\"M11.68 11.007L9.673 9V9a5.287 5.287 0 001.249-3.424 5.298 5.298 0 00-1.557-3.759A5.298 5.298 0 005.605.26a5.298 5.298 0 00-3.759 1.557A5.298 5.298 0 00.29 5.577a5.297 5.297 0 001.557 3.759 5.298 5.298 0 003.759 1.556 5.283 5.283 0 003.398-1.227l.003.003 2.006 2.006a.47.47 0 00.667 0 .471.471 0 000-.667zM5.606 9.984a4.378 4.378 0 01-3.117-1.291A4.378 4.378 0 011.2 5.576c0-1.177.458-2.284 1.29-3.116a4.378 4.378 0 013.117-1.29c1.177 0 2.284.458 3.116 1.29a4.378 4.378 0 011.291 3.116 4.378 4.378 0 01-1.29 3.117 4.378 4.378 0 01-3.117 1.29z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sousuo.svg
// module id = 508
// module chunks = 4